// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Fonts/N27-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/Fonts/N27-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: PP-Nuebit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  @font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  @font-face {
    font-family: N27-Bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  @font-face {
    font-family: N27-Light;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  @font-face {
    font-family: N27-Medium;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }

.task-submission-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    /* padding: 2rem 2rem 2rem 2rem; */
    background-color: white;
    width: 100%;
  }
  .task-submission-title-container{
    display: flex;
    justify-content: center;
    padding: 2rem 2rem 2rem 2rem;
    align-items: center;
    width:96%;
  }
  .task-submission-title {
    font-size: 10rem;
    margin:0;
    font-family: PP-Nuebit ;
    text-align: center;
  }
  .task-submission-step-container{
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 95.8%;

  }
  
  .task-submission-sidebar {
   display: flex;
   flex-direction: column;
   width: 100%;
   position: sticky;
   top:0;
  }
  
  .task-submission-nav {
    display: flex;
    flex-direction: row;
    list-style: none;
    width:100%;
    padding: 0;
    margin: 0;
  }
  
  .task-submission-nav-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border: 1pt solid gray;
    background-color: white;
    cursor: pointer;
    height: 2rem;
    width:15rem;
    font-family: N27;
    font-size: 1.5rem;
  }
  
  .task-submission-nav-item.active {
    background-color: #ff4f4f;
    color: white;
  }
  
  .task-submission-content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding: 2rem 2rem 2rem 2rem;
  }
  
  
  .task-submission-step {
    margin-bottom: 2rem;
    width:98%;
    padding: 1rem;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .task-submission-step.active-step {
    background-color: #fcf7f7;
  }
  
  .task-submission-heading {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    color: #333;
    font-family: N27 ;
  }
  
  .task-submission-detail {
    margin-bottom: 1rem;
    color: #555;
    line-height: 1.6;
    font-family: N27;
    text-align: left;
  }
  
  .task-submission-list {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  .task-submission-item {
    margin-bottom: 0.5rem;
    font-family: N27;
    text-align: left;
  }
  
  .task-submission-image {
    max-width: 100%;
    border-radius: 8px;
    margin-top: 1rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/Guidelines/TaskSubmission.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4CAAoD;EACtD;EACA;IACE,gBAAgB;IAChB,4CAAiD;EACnD;EACA;IACE,qBAAqB;IACrB,4CAA8C;EAChD;EACA;IACE,sBAAsB;IACtB,4CAA+C;EACjD;EACA;IACE,uBAAuB;IACvB,4CAAgD;EAClD;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,kCAAkC;IAClC,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,QAAQ;IACR,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;;EAEd;;EAEA;GACC,aAAa;GACb,sBAAsB;GACtB,WAAW;GACX,gBAAgB;GAChB,KAAK;EACN;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,4BAA4B;EAC9B;;;EAGA;IACE,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":["@font-face {\n    font-family: PP-Nuebit;\n    src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27;\n    src: url(\"../../../assets/Fonts/N27-Regular.otf\");\n  }\n  @font-face {\n    font-family: N27-Bold;\n    src: url(\"../../../assets/Fonts/N27-Bold.otf\");\n  }\n  @font-face {\n    font-family: N27-Light;\n    src: url(\"../../../assets/Fonts/N27-Light.otf\");\n  }\n  @font-face {\n    font-family: N27-Medium;\n    src: url(\"../../../assets/Fonts/N27-Medium.otf\");\n  }\n\n.task-submission-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    /* padding: 2rem 2rem 2rem 2rem; */\n    background-color: white;\n    width: 100%;\n  }\n  .task-submission-title-container{\n    display: flex;\n    justify-content: center;\n    padding: 2rem 2rem 2rem 2rem;\n    align-items: center;\n    width:96%;\n  }\n  .task-submission-title {\n    font-size: 10rem;\n    margin:0;\n    font-family: PP-Nuebit ;\n    text-align: center;\n  }\n  .task-submission-step-container{\n    display:flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 95.8%;\n\n  }\n  \n  .task-submission-sidebar {\n   display: flex;\n   flex-direction: column;\n   width: 100%;\n   position: sticky;\n   top:0;\n  }\n  \n  .task-submission-nav {\n    display: flex;\n    flex-direction: row;\n    list-style: none;\n    width:100%;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .task-submission-nav-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem 1rem;\n    border: 1pt solid gray;\n    background-color: white;\n    cursor: pointer;\n    height: 2rem;\n    width:15rem;\n    font-family: N27;\n    font-size: 1.5rem;\n  }\n  \n  .task-submission-nav-item.active {\n    background-color: #ff4f4f;\n    color: white;\n  }\n  \n  .task-submission-content {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 100%;\n    padding: 2rem 2rem 2rem 2rem;\n  }\n  \n  \n  .task-submission-step {\n    margin-bottom: 2rem;\n    width:98%;\n    padding: 1rem;\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .task-submission-step.active-step {\n    background-color: #fcf7f7;\n  }\n  \n  .task-submission-heading {\n    font-size: 2.5rem;\n    margin-bottom: 0.5rem;\n    color: #333;\n    font-family: N27 ;\n  }\n  \n  .task-submission-detail {\n    margin-bottom: 1rem;\n    color: #555;\n    line-height: 1.6;\n    font-family: N27;\n    text-align: left;\n  }\n  \n  .task-submission-list {\n    list-style-type: disc;\n    padding-left: 20px;\n  }\n  \n  .task-submission-item {\n    margin-bottom: 0.5rem;\n    font-family: N27;\n    text-align: left;\n  }\n  \n  .task-submission-image {\n    max-width: 100%;\n    border-radius: 8px;\n    margin-top: 1rem;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
